export default "__VITE_ASSET__B94zJy6z__"